<template>
  <div class="chart-container">
    <chart :height="height1" :width="width1" :path="path1" :id="id1" :chart_type="chart_type1" :params="params1"
           :lazy=true
           :yAxisLabelBasePx="yAxisLabelBasePx1"
           :expand-bottom-axis="expandBottomAxis"
           :show_mode="show_mode1" :area_color="area_color1"/>
  </div>
</template>

<script>
import Chart from '@/components/Charts/Linemarker'

export default {
  name: 'LineChart',
  props: {
    path: {
      type: String
    }, id: {
      type: String
    },
    chart_type: {
      type: String,
      default: "bar"
    }, height: {
      type: String
    }, width: {
      type: String
    }, show_mode: {
      type: String,
      default: "complex"
    }, area_color: {
      type: String,
      default: "#6DF4BA"
    }, params: {},
    /** 透传 Linemarker：Y 轴刻度字号的 px 基准（会再走 ls3ChartFont），不传则 20 */
    yAxisLabelBasePx: {
      type: Number,
      default: undefined
    },
    /** 横轴类目较多时加大 grid 底部留白并倾斜标签，避免省份名被裁切 */
    expandBottomAxis: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    '$route': function (to, from) {
      if (to != from) {
        this.initChart();
      }
    }
  },
  data() {
    return {
      path1: this.path,
      id1: this.id,
      chart_type1: this.chart_type,
      height1: this.height,
      width1: this.width,
      params1: this.params,
      yAxisLabelBasePx1: this.yAxisLabelBasePx,
      show_mode1: this.show_mode,
      area_color1: this.area_color,
    }
  },
  components: {Chart}
}
</script>

<style scoped>
.chart-container {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>
